import { ExamPaperHeader } from './ExamPaperHeader';
export default ExamPaperHeader;